import React from 'react'
import { Popconfirm, Popover, message, Select } from 'antd';
const { Option } = Select

class PopconfirmOrPopover extends React.Component {
  state = {
    popconfirmVisible: false,
    value: null
  }
  confirm = () => {
    this.setState({ popconfirmVisible: false });
    message.loading(`Classifying all as ${this.state.value}`);
    this.props.onConfirm(this.state.value)
  }
  confirmThenHandle = (value) => {
    this.setState({ value });
    if (this.props.shouldConfirm) {
      return this.setState({ popconfirmVisible: true });
    }
    message.loading(`Classifying as ${value}`);
    this.props.onConfirm(value)
  }
  cancel = () => {
    this.setState({ popconfirmVisible: false });
  }
  handleVisibleChange = (popconfirmVisible) => {
    if (!popconfirmVisible) { // handles clicks out
      this.setState({ popconfirmVisible });
      return;
    }
  }
  render() {
    const { children, shouldConfirm, title, confirmTitle, content: InnerComponent} = this.props
    return (
      <div>
        {this.state.popconfirmVisible ?
          (
            <Popconfirm
              placement="bottom"
              title={confirmTitle}
              visible={this.state.popconfirmVisible}
              onVisibleChange={this.handleVisibleChange}
              onConfirm={this.confirm}
              onCancel={this.cancel}
              okText="Yes"
              cancelText="No"
            >
              {children}
            </Popconfirm>
          ) : (
            <Popover
              placement="bottom"
              trigger='click'
              content={
                <InnerComponent confirmThenHandle={this.confirmThenHandle} />
              }
              title={title}
            >
              {children}
            </Popover>
          )
        }
      </div>
    );
  }
}
export default PopconfirmOrPopover



// WEBPACK FOOTER //
// ./src/core/PopconfirmOrPopover.js